import { Injectable } from '@angular/core';
import { MonitoringProvider } from './contracts/monitoring-provider.interface';
import { MonitoringProviderId } from './models/monitoring-config.model';

@Injectable({
  providedIn: 'root',
})
export class MonitoringProviderFactory {
  async create(providerId: MonitoringProviderId): Promise<MonitoringProvider> {
    switch (providerId) {
      case 'logrocket': {
        const module = await import('./providers/logrocket.provider');
        return new module.LogRocketProvider();
      }
      case 'openreplay': {
        const module = await import('./providers/openreplay.provider');
        return new module.OpenReplayProvider();
      }
    }
  }
}
